<template>
  <div class="home">
    <div class="container">
      <div class="row">
        <div class="col content">
          <h1>Frequently Asked Questions</h1>
          <p>Please review the FAQ below. If you have any issues that are not answered, please send an email to this address: <a href="mailto:videoissue@oxfordclub.com?subject=Livestream">videoissue@oxfordclub.com</a>.</p>

          <h2>When will the broadcast start?</h2>
          <p>The video player will begin to play on {{ startDay }}, {{ startMonth }} {{ startDate.getDate() }} at {{ startTime }} ({{ timezoneStr }}).</p>

          <h2>How do I know when a video is archived and available to view again?</h2>
          <p>After each event concludes they will be added to the "event posts" per each days archive.</p>
          <p>The events can be accessed by selecting the following icon in the top right corner of each days video player.</p>
          <p>At the end of they day, links directly to each event will be selectable as well.</p>

          <h2>Where are the volume controls on the video player?</h2>
          <p>You can control the volume of the player by clicking on the icon located on the left side of the control bar.</p>

          <h2>Can my computer handle the "live" feed?</h2>
          <p>Absolutely. As long as you have a relatively modern computer with normal Internet access, you should be fine. The only rule: The old-fashioned dial-up modems aren't fast enough to stream live video. If you have dial-up, you can still call your phone or cable company in advance and have them set you up with a proper Internet connection.</p>

          <h2>What if I have to get up to go to the bathroom, or leave for work? Will I miss opportunities?</h2>
          <p>No. As the event unfolds, we'll begin archiving the live footage hour-by-hour. All the presentations will appear in our archives, so you can log on at any time and review any presentation you missed. They'll remain there for you to review.</p>

          <h2>What if I lose my connection or am receiving an error message?</h2>
          <p>
            If you are having problems with the video connection, please refresh the video page (by pressing the refresh button on your browser) and try again. Please be sure you are viewing the streaming video from the correct page, located here: <a href="/">livestream.privatewealthseminars.com</a>.
          </p>

          <h2>Do I have to watch the whole conference?</h2>
          <p>No, you can select which of the multimillionaires, bankers and investment gurus you listen to. You'll be able to view the complete schedule ahead of time. Even so, you're free to go back and listen to the complete archives at any time.</p>

          <h2>What else do I get when I log onto the <b>Private Wealth Seminars Livestream</b> website?</h2>
          <p>The website will serve as your "command center" for the event. It features the live-stream video box, where most of the action will take place. It also features all the archived presentations in a sidebar, labeled by investing subject and dated. Our team will be writing up notes as the presentations unfold, too. These "live blogs" will contain salient details from the presentations, in writing, such as recommended stocks, predictions and the like.</p>
          <p>You can skim these "crib sheets" and invest accordingly.</p>
        </div>
        <div class="col sidebar">
          <Sidebar />
        </div>
      </div> 
    </div>
  </div>
</template>

<script>
import db from '../db';
import auth from '../auth';
import helpers from '../helpers';
import Sidebar from './Sidebar';

export default {
  name: 'FAQ',
  components: {
    Sidebar
  },
  data() {
    return {
      startPresentation: undefined,
      startDate: helpers.now(),
      startDay: undefined,
      startMonth: undefined,
      startTime: undefined,
      timezoneStr: 'Eastern Time',
    };
  },
  firebase: helpers.getFirebaseObject(db),
  beforeMount() { auth.requireLogin(); },
  mounted() { this.updateData(); },
  methods: {
    updateData() {
      if (!this.speakers || this.speakers.length === 0 ||
          !this.options  || this.options.length  === 0) {
        setTimeout(this.updateData, 500);
        return;
      }
      this.startPresentation = this.getStartPresentation();
      if (this.startPresentation) {
        this.startDate = this.getStartDate();
        this.startDay = this.getStartDay();
        this.startMonth = this.getStartMonth();
        this.startTime = this.getStartTime();
        this.timezoneStr = this.getTimezoneStr();
      } else {
        setTimeout(this.updateData, 500);
      }
    },

    getStartPresentation() {
      let presentations = helpers.getPresentationsByDay(this.speakers, this.options);
      if (presentations) return presentations[0][0];
    },

    getStartDate() {
      let p = this.startPresentation;
      let offset = helpers.getUTCOffset(this.options);
      return helpers.getTimestamp(p.date, p.start_time, offset);
    },

    getStartDay() {
      if (!this.startDate) return;

      let days = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ];

      return days[this.startDate.getDay()];
    },

    getStartMonth() {
      if (!this.startDate) return;

      let months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ];

      return months[this.startDate.getMonth()];
    },

    getStartTime() {
      return this.startPresentation.start_time;
    },

    getTimezoneStr() {
      try {
        let offset = helpers.getUTCOffset(this.options);
        let timezoneAbbr = helpers.getTimezoneStr(offset);

        if (timezoneAbbr === 'PST' || timezoneAbbr === 'PDT') {
          return 'Pacific Time';
        }
        if (timezoneAbbr === 'EST' || timezoneAbbr === 'EDT') {
          return 'Eastern Time';
        }
        if (timezoneAbbr === 'CST') return 'Mountain Time';
      }
      catch (err) { console.log(err); }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
  background-color: #27476620;
  padding: 8px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 1.3em;
  font-weight: normal;
  margin-top: 30px;
  color: #000;
}
.processing-message {
  background: #efefef;
  border: 1px solid #ccc;
  padding: 30px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/FAQ.vue